module.exports = __webpack_public_path__ + "static/media/brewing-thumb.8e5d21b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/brewing-thumb.jpg
// module id = 582
// module chunks = 0